import { type WorkflowTemplateType } from "../schemas/WorkflowTemplateSchemas.ts";
import { fetchAndCollate, getFilterObject } from "../util/index.ts";
import type {
  GetListResponseType,
  ResourceAdapterType,
} from "../util/index.ts";
import { restAPI } from "./api.ts";

export type WorkflowTemplateWithOwnerAndCreatedByNameType =
  WorkflowTemplateType & {
    workflow_owner_name?: string;
    created_by_name?: string;
  };

export type WorkflowTemplateAdapterType = Pick<
  ResourceAdapterType<WorkflowTemplateType>,
  "getList" | "getOne" | "updateOne"
>;

export const WorkflowTemplatesAdapter: WorkflowTemplateAdapterType = {
  /**
   * Get the complete list of Workflow Templates
   * @see https://staging-carbon-hub-api.s3.us-west-2.amazonaws.com/openapi/index.html#/workflow_templates/search_workflow_templates
   */
  getList: async ({ page, pageSize, sortBy, sortDirection, filters }) =>
    fetchAndCollate(
      async ({ page, pageSize }) =>
        await restAPI.nodeAPI.POST<GetListResponseType<WorkflowTemplateType>>({
          endpoint: "/workflow_templates/search",
          body: {
            sort_by: sortBy,
            sort_direction: sortDirection,
            page: page,
            page_size: pageSize,
            filter: getFilterObject(filters),
          },
        }),
      page,
      pageSize
    ),
  /**
   * Get the detail info Workflow Templates
   * @see https://staging-carbon-hub-api.s3.us-west-2.amazonaws.com/openapi/index.html#/workflow_templates/get_workflow_template
   */
  getOne: async ({ id }) => {
    const resp = await restAPI.nodeAPI.GET<WorkflowTemplateType>({
      endpoint: `/workflow_templates/${id}`,
    });
    return { data: resp };
  },

  /**
   * Update a workflow template
   * @see https://staging-carbon-hub-api.s3.us-west-2.amazonaws.com/openapi/index.html#/workflow_templates/put_workflow_template
   */
  updateOne: async ({
    id,
    data,
  }: {
    id: string;
    data: Partial<WorkflowTemplateType>;
  }) => {
    const resp = await restAPI.nodeAPI.PUT<WorkflowTemplateType>({
      endpoint: `/workflow_templates/${id}`,
      body: data,
    });

    return {
      data: resp,
    };
  },
};
